const initialStatuses = ['active'];

export { initialStatuses };
